<template>
  <div v-if="body_show">
    <div class="task_f">
      <h2 v-html="text" v-if="text != ''"></h2>
      <h2 v-else>项目攻略是帮助你攻克任务的难点的。这里总结和整合了任务完成的工具、模型和套路。</h2>
      <ul class="faq">
        <li v-for="(item,index) in faq_list" :key="index">
          <router-link class="a" :to="'/faq_content?id='+ item.id + '&cid=' + cid">
            <div class="faq_l">
              {{item.name}}
            </div>
            <img src="@a/href.png" />
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {
  getfaq
} from "@/api/course";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        cid: "",
        pid: "",
        body_show: false,
        text: "",
        faq_list: []
      }
    },
    methods: {
      pullData() {
        getfaq({
            type: "all",
            cid: this.$route.query.cid,
            cpid: this.$route.query.cpid
          })
          .then((data) => {
            this.body_show = true;
            this.faq_list = data.data;
            this.text = data.text;
            this.cid = this.$route.query.cid;
          })

      }
    },
    created() {
      this.pullData();
      shareCon("course",this);
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.task_f {
  padding: 0 changeRem(.6)+px;
  margin: 0 auto;
  margin-top: changeRem(.8)+px;
  text-align: left;
  h2 {
    color: #EB5032;
    font-size: changeRem(.64)+px;
    line-height: changeRem(.96)+px;
  }
  .faq {
    width: 100%;
    li {
      width: 100%;
      height: changeRem(1.8)+px;
      line-height: changeRem(1.8)+px;
      background: #fff;
      border-radius: changeRem(.16)+px;
      padding: 0 changeRem(.6)+px;
      margin-top: changeRem(.6)+px;
      .faq_l {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
        text-align: justify;
        width: changeRem(10.4)+px;
        color: #333;
        font-size: changeRem(.56)+px;
      }
      img {
        width: changeRem(.5)+px;
        float: right;
        margin-top: changeRem(.7)+px;
      }
    }
  }
}
</style>
